<!-- 講座ページのヘッダーを表示するコンポーネント -->
<script setup lang="ts">
  import { PlanInfo } from "~/entities/PlanInfo";

  interface Props {
    planInfo: PlanInfo;
    isOwner: boolean;
  }
  const props = withDefaults(defineProps<Props>(), {
    planInfo: undefined,
    isOwner: false,
  });

  const showJoinButton = computed<boolean>(() => {
    // オーナーは入会ボタンを表示しない
    return !props.isOwner;
  });
</script>

<template>
  <div>
    <div class="w-100 bg-monochrome-04 mb-4 pa-4">
      <OrganismsPlanSummary :plan-info="planInfo" />
      <!-- タグ情報 -->
      <div v-if="planInfo?.tags" class="w-100 d-flex flex-wrap my-2">
        <AtomsTagLabel
          v-for="(tag, i) in planInfo?.tags"
          :key="i"
          class="mx-1 text-subtitle-2"
          :tag="tag"
        ></AtomsTagLabel>
      </div>
    </div>

    <OrganismsPlanJoinPanel v-if="showJoinButton" :plan-info="planInfo" />

    <!-- 講座提供者情報 -->
    <template v-if="planInfo?.isInvestmentAdvice">
      <div class="plan-owner-presents mt-4">{{ planInfo?.contractPartnerName }}が提供する講座です</div>
      <div class="plan-owner-rights">{{ planInfo?.financialNo }}</div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .plan-owner-presents,
  .plan-owner-rights {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    text-align: left;
  }
</style>
